import { Divider, InputNumber, Tooltip } from "antd";
import Form from "antd/lib/form/Form";
import { Formik } from "formik";
import React, { createContext, useContext, useRef } from "react";
import FormItem from "antd/lib/form/FormItem";
import ReactQuill from "react-quill";
import "../styles/ebendodaily.css";

import "react-quill/dist/quill.snow.css";
import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";

import formatNumber from "accounting-js/lib/formatNumber.js";
import { AgGridReact } from "ag-grid-react";

import { reactQuiltoolbarOptions } from "../../../Utility/modules/helpers";
import { MessageBar, MessageBarType } from "@fluentui/react";
const _ = require("underscore");
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
export const EbendoDailyProductionForm = observer(() => {
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  const formGrid = useRef(null);

  const getTotal = (col) =>
    formatNumber(
      _.reduce(
        _.pluck([...ebendoDailyProductionStore.wellparameters.values()], col),
        function (memo, num) {
          return (
            Number(memo) + Number(_.isNull(num) || _.isUndefined(num) ? 0 : num)
          );
        },
        0
      ),
      {
        precision: 4,
        thousand: ",",
      }
    );
  const wellParaColumns = [
    {
      headerName: "#",
      valueGetter: "node.rowIndex + 1",
      width: 50,
      resizable: true,
      sortable: true,
      pivot: false,
      editable: false,
      pinnedRowCellRenderer: (props) => {
        return "";
      },
    },
    {
      width: 80,
      hide: true,
      pivot: false,
      pinnedRowCellRenderer: (props) => {
        return "";
      },
    },
    {
      headerName: "Well",
      field: "wellName",
      sortable: true,
      resizable: true,
      editable: false,

      width: 150,
      pinnedRowCellRenderer: (props) => {
        return "Total Well Productions";
      },
      pinnedRowCellRendererParams: {
        style: { color: "red" },
      },
    },

    {
      headerName: "Well line up",
      field: "wellLineUp",
      width: 100,
      sortable: true,
      resizable: true,

      pinnedRowCellRenderer: (props) => {
        return "";
      },
    },
    {
      headerName: 'Choke X/64"',
      field: "choke",
      width: 100,
      sortable: true,
      resizable: true,
      pinnedRowCellRenderer: (props) => {
        return "";
      },
    },
    {
      headerName: "Hours Online",
      field: "hoursOnline",
      width: 100,
      sortable: true,
      resizable: true,
    },
    {
      headerName: "FTHP (psig)",
      field: "fthp",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "WHT (°F)",
      field: "wht",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "FLP (psig)",
      field: "flp",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "CHP  (psig)",
      field: "chp",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "BLPD",
      field: "blpd",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
      pinnedRowCellRendererParams: {
        style: { color: "red" },
      },
      pinnedRowCellRenderer: (props) => {
        return ebendoDailyProductionStore.totalBLPD;
      },
    },
    {
      headerName: "%BS&W",
      field: "bsw",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "OIL (BOPD)",
      field: "oil",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "WATER (BWPD)",
      field: "water",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "GAS (MMSCF/D)",
      field: "gas",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "GOR  (SCF/BBL)",
      field: "gor",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "GLR  (SCF/BBL)",
      field: "glr",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "API",
      field: "api",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
  ];
  return (
    <Formik
      initialValues={toJS(ebendoDailyProductionStore.initFormaData)}
      enableReinitialize={true}
    >
      {({ values }) => (
        <Form
          layout="vertical"
          labelAlign="left"
          style={{ background: "#fff", padding: "10px" }}
        >
          <div className="ms-Grid" dir="ltr">
            {/*  <FormItem
              label="Total BLPD"
              labelAlign="left"
              className="add-border"
            >
              <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                {formatNumber(ebendoDailyProductionStore.totalBLPD, {
                  precision: 2,
                  thousand: ",",
                })}
              </span>
            </FormItem> */}
            <div className="ms-Grid-row">
              <Divider>Production Figures</Divider>
              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Bulk Liquid Produced (BLPD)">
                  <FormItem
                    label="Bulk Liquid Produced (BLPD)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="gas"
                      value={values?.blpd}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.blpd = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>

              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Net Production (bopd)">
                  {" "}
                  <FormItem
                    label="Oil (bopd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="oil"
                      value={values?.oil}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.oil = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Station Water Production (bwpd)">
                  <FormItem
                    label="Water (bwpd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="water"
                      value={values?.water}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.water = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>

              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Condensate from Gas Plant (bopd) ">
                  <FormItem
                    label="Condensate (bopd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="condensate"
                      value={values?.condensate}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.condensate =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Station Gas Production (Mmscfd)">
                  <FormItem
                    label="Gas (Mmscfd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="gas"
                      value={values?.gas}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.gas = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>

              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Fuel Gas Consumed in Operations (Mmscfd)">
                  <FormItem
                    label="Fuel Gas (Mmscfd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="fuelGas"
                      value={values?.fuelGas}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.fuelGas =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm3">
                <Tooltip title="Total  Flared Gas (Mmscfd)">
                  <FormItem
                    label="Total  Flared (Mmscfd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="flareGas"
                      value={values?.flareGas}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.flareGas =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
            </div>

            <div className="ms-Grid-row">
              <Divider>Evacuation Figures</Divider>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Crude injection to GGF(bbls)">
                  <FormItem
                    label="Crude injection to GGF(bbls)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="crudeInjectionGGF"
                      value={values?.crudeInjectionGGF}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.crudeInjectionGGF =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Total Gas Supplied  To gas Plant (Mmscfd) ">
                  <FormItem
                    label="Gas supplied to Gas plant(Mmscfd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="gasSuppliedToGasPlant"
                      value={values?.gasSuppliedToGasPlant}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.gasSuppliedToGasPlant =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Crude Exported through Ase River ">
                  <FormItem
                    label="Ase River Crude Export (bopd)"
                    labelAlign="left"
                    style={{ color: "red" }}
                    className="manual-entry"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="aseRiverExport"
                      value={values?.aseRiverExport}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.aseRiverExport =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Crude Exported through Forcados ">
                  <FormItem
                    label="Forcados Crude Export (bopd)"
                    labelAlign="left"
                    className="manual-entry"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="forcadosExport"
                      value={values?.forcadosExport}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.forcadosExport =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>

              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Evacuated Condensate(bopd)">
                  <FormItem
                    label="Evacuated Condensate(bopd)"
                    labelAlign="left"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="evacuatedCondensate"
                      value={values?.evacuatedCondensate}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.evacuatedCondensate =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Ase River Daily Uptime (hrs) ">
                  <FormItem
                    label="Ase River Daily Uptime(hrs)"
                    labelAlign="left"
                    className="manual-entry"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="aseRiverUptime"
                      value={values?.aseRiverUptime}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.aseRiverUptime =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Forcados Daily Uptime (hrs)">
                  <FormItem
                    label="Forcados  Daily Uptime(hrs)"
                    labelAlign="left"
                    className="manual-entry"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="forcadosUptime"
                      value={values?.forcadosUptime}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.forcadosUptime =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
            </div>

            <div className="ms-Grid-row">
              <Divider>Other Station Figures</Divider>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Station Downtime(hrs)">
                  <FormItem
                    label="Station Downtime(hrs)"
                    labelAlign="left"
                    className="manual-entry"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="stationDownHrs"
                      value={values?.stationDownHrs}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.stationDownHrs =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Station API (@60 degF) ">
                  <FormItem label="Station API (@60 degF)" labelAlign="left">
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="stationAPI"
                      value={values?.stationAPI}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.stationAPI =
                          value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <Tooltip title="Station BS&W (%) ">
                  <FormItem
                    label="Station BS&W (%)"
                    labelAlign="left"
                    className="manual-entry"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "60%" }}
                      name="bsw"
                      value={values?.bsw}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.bsw = value;
                      }}
                    />
                  </FormItem>
                </Tooltip>
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <Tooltip title="Remarks or Comments from the field  ">
                  <FormItem label="PRODUCTION REMARKS" labelAlign="left">
                    <ReactQuill
                      modules={{ toolbar: reactQuiltoolbarOptions }}
                      onChange={(value) => {
                        ebendoDailyProductionStore.initFormaData.remarks =
                          value;
                      }}
                      value={ebendoDailyProductionStore.initFormaData?.remarks}
                      style={{ minHeight: "300px" }}
                      placeholder="Enter REMARKS here"
                    />{" "}
                  </FormItem>{" "}
                </Tooltip>
              </div>
            </div>

            <Divider>Well Production Contributions</Divider>
            <MessageBar messageBarType={MessageBarType.info}>Double click table cell to edit value</MessageBar>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <div
                  className="ag-theme-balham qikreach-grid-fill"
                  style={{
                    minHeight: "30vh",
                    height: "40vh",
                    width: "100%",
                    maxHeight: "80vh",
                  }}
                >
                  <AgGridReact
                    rowData={[
                      ...ebendoDailyProductionStore.wellparameters.values(),
                    ]}
                    ref={formGrid}
                    gridOptions={{
                      defaultColDef: {
                        sortable: true,
                        editable: true,
                        enableValue: true,
                        filter: true,
                      },

                      rowSelection: "single",
                      pagination: true,
                      columnDefs: wellParaColumns,
                      animateRows: true,
                      statusBar: {
                        statusPanels: [
                          {
                            statusPanel: "agTotalRowCountComponent",
                            align: "center",
                          },
                        ],
                      },
                      columnTypes: {
                        numberColumn: {
                          width: 130,
                          filter: "agNumberColumnFilter",
                        },

                        nonEditableColumn: { editable: false },
                      },
                    }}
                    rowSelection={{ mode: "singleRow", checkboxes: true, enableClickSelection: true }}
                    copyHeadersToClipboard={true}
                    pinnedBottomRowData={[
                      {
                        blpd: getTotal("blpd"),
                        oil: getTotal("oil"),
                        gas: getTotal("gas"),
                        water: getTotal("water"),
                      },
                    ]}
                  ></AgGridReact>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
});

